import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface ControlPoint { timestamp: string; value: number; sigma_level: number; rule_violations: string[]; }
export interface ControlChartData { metric_type: string; mean: number; stddev: number; ucl: number; lcl: number; points: ControlPoint[]; }

export function useControlCharts(metric = 'latency_p95') {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [data, setData] = useState<ControlChartData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<ControlChartData & { charts?: ControlChartData[] }>(`/api/dashboard/control-charts?metric_type=${encodeURIComponent(metric)}`, token)
      .then((d) => {
        if (cancelled) return;
        // API may return {charts: [...]} wrapper or direct data
        const chart = d.charts?.[0] ?? (d.points ? d : null);
        setData(chart);
        setLoading(false);
      })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, metric, refreshKey, logout]);

  return { data, loading };
}
